import _styled from "styled-components";
import React, { useState, useEffect, useContext } from 'react';
import classnames from 'classnames';
import smoothscroll from 'smoothscroll-polyfill';
import { AnalyticsContext, AnalyticsLocationConsumer, trackEvent } from 'latitude-analytics';
import { COLOR } from '@latitude/core/utils/constants';
import AccordionButton from './AccordionButton';
import AccordionContent from './AccordionContent';
import './_accordion.scss';

var getBackgroundCssClass = function getBackgroundCssClass(color) {
  switch (color) {
    case 'white':
      return 'bg-white';

    case 'blue-light':
      return 'bg-brand-lighter';

    case 'grey-light':
      return 'bg-lightest';

    default:
      return 'bg-white';
  }
};

var Accordion = function Accordion(props) {
  var borderedChildren = props.borderedChildren,
      className = props.className,
      style = props.style,
      _props$contentBgColor = props.contentBgColor,
      contentBgColor = _props$contentBgColor === void 0 ? COLOR.WHITE : _props$contentBgColor,
      category = props.category,
      _props$fgColor = props.fgColor,
      fgColor = _props$fgColor === void 0 ? COLOR.BLACK : _props$fgColor,
      highlightActive = props.highlightActive,
      isChild = props.isChild,
      items = props.items,
      _props$titleBgColor = props.titleBgColor,
      titleBgColor = _props$titleBgColor === void 0 ? COLOR.GREY12 : _props$titleBgColor,
      minimumMargin = props.minimumMargin,
      groupActiveIndex = props.groupActiveIndex,
      setGroupActiveIndex = props.setGroupActiveIndex,
      hasSmoothScroll = props.hasSmoothScroll;
  var defaultActiveIndex = items.findIndex(function (item) {
    return item.initiallyActive;
  });

  var _useContext = useContext(AnalyticsContext),
      analytics = _useContext[0];

  var _useState = useState(defaultActiveIndex),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1]; // set the active index, because on load the index is "-1" nothing is set


  var hasTwoLevels = items.some(function (item) {
    return Array.isArray(item.content);
  }); // boolean: whether acc has 2 levels

  useEffect(function () {
    smoothscroll.polyfill();
  }, []);
  /*
   * Provides support for multi accordion interaction
   * Expands/collapses group of accordions based on active index
   */

  useEffect(function () {
    if (groupActiveIndex !== undefined) {
      setActiveIndex(groupActiveIndex);
    }
  }, [groupActiveIndex]);

  var handleOnClick = function handleOnClick(item, event, location) {
    /*
     * If there is a category prop (passed in from AccordionSideBar or Nested Accordion),
     * then use it for location else, use context provided location.
     */
    if (category) {
      location = category;
    }

    trackEvent(analytics, {
      category: 'accordion',
      action: 'in-page-navigation',
      label: item.trackEventData ? item.trackEventData.label : event.target.innerText.split(" ($")[0],
      // Do not track the dollar amount if it exists
      location: location
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classnames('accordion', hasTwoLevels && 'accordion--two-level', isChild && 'accordion--child', isChild && borderedChildren && 'accordion--bordered', highlightActive && 'accordion--hl-active', minimumMargin && 'accordion--min-margin', className)
  }, items.map(function (item, index) {
    var isOpen = activeIndex === index;
    var buttonId = item.id + "-button";
    var isParent = Array.isArray(item.content);
    var showHighlightedActive = highlightActive && isOpen;
    return /*#__PURE__*/React.createElement(AnalyticsLocationConsumer, {
      key: index
    }, function (location) {
      return /*#__PURE__*/React.createElement(_StyledDiv, {
        "data-id": item.id,
        className: classnames('accordion__item', isOpen && 'is-open'),
        key: item.id,
        $_css: titleBgColor,
        $_css2: fgColor,
        $_css3: contentBgColor,
        $_css4: fgColor
      }, /*#__PURE__*/React.createElement(AccordionButton, {
        buttonid: buttonId,
        fgColor: showHighlightedActive && 'white' || fgColor,
        onClick: function onClick() {
          var active = isOpen ? -1 : index;
          setActiveIndex(active);
          setGroupActiveIndex && setGroupActiveIndex(active);
          !isOpen && handleOnClick(item, event, location);
        },
        className: classnames(showHighlightedActive && 'bg-brand-bright' || getBackgroundCssClass(titleBgColor), !isChild && 'font-weight-bold'),
        itemId: item.id,
        isOpen: isOpen,
        iconName: item.iconName,
        title: item.title,
        activeIndex: activeIndex,
        isSticky: !isChild,
        hasSmoothScroll: hasSmoothScroll
      }), isOpen && /*#__PURE__*/React.createElement(AccordionContent, {
        id: item.id,
        buttonId: buttonId,
        isParent: isParent,
        isChild: isChild,
        contentBgColor: getBackgroundCssClass(contentBgColor),
        content: item.content,
        activeIndex: activeIndex,
        style: style,
        nestedAccordion: /*#__PURE__*/React.createElement(Accordion, {
          isChild: true,
          titleBgColor: "white",
          contentBgColor: "white",
          fgColor: fgColor,
          borderedChildren: borderedChildren,
          items: item.content
        }),
        hasSmoothScroll: hasSmoothScroll
      }));
    });
  }));
};

Accordion.defaultProps = {
  fgColor: 'grey-dark'
};
export default Accordion;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "Accordion___StyledDiv",
  componentId: "sc-bl7yzn-0"
})([".link-block{background-color:", "!important;color:", ";}.accordion__item-body{background-color:", "!important;}svg{color:", ";}"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
});